
var app = angular.module('planillas', [
    /*
     * Order is not important. Angular makes a
     * pass to register all of the modules listed
     * and then when app.dashboard tries to use app.data,
     * its components are available.
     */

    /*
     * Everybody has access to these.
     * We could place these under every feature area,
     * but this is easier to maintain.
     */ 
    'app.core',
    'app.widgets',

    /*
     * Feature areas
    */
   'app.layout',
   'app.login',
   'app.usuarios',
   'app.grupos',
   'app.permisos',
   'app.companias',
   'app.periodos',
   'app.tiposPlanilla',
   'app.centrosCosto',
   'app.departamentos',
   'app.bancos',
   'app.turnos',
   'app.puestos',
   'app.nacionalidades',
   'app.empleados',
   'app.principal',
   'app.variables',
   'app.tiposAccionPersonal',
   'app.impuestosRenta',
   'app.unidades',
   'app.calendarizaciones',
   'app.cantidades',
   'app.deducibles',
   'app.devengados',
   'app.procesarPlanilla',
   'app.archivoReloj',
   'app.bloqueos',
   'app.reportes',
   'app.accionesPersonal',
   'app.comprobantesPago',
   'app.cantidadesDestajo',
   'app.centrosCostoTercerNivel',
   'app.cuentasContables',
   'app.horarios',
   'app.vacacionesDetalle',
   'app.areas',
   'app.procesosMasivos',
   'app.archivoAsociacion',
   'app.archivoCCSS',
   'app.perfilesAsiento',
   'app.feriados',
   'app.archivoBNCR'
]);